// extracted by mini-css-extract-plugin
export default {"wrapper":"DeviceInfo_style_wrapper__AbMod","rotate":"DeviceInfo_style_rotate__1bs8Z"};